import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticCampervanMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */

  _getAdsListSemanticConfigKey = ({version}) => {
    const hasVersion = Boolean(version)

    // These are the two combinations of SEO Metadata typologies
    // for campervans ads-list pages [/campers/]
    const isDefault = !hasVersion
    const isVersion = hasVersion

    switch (true) {
      case isDefault:
        return 'default'
      case isVersion:
        return 'version'
      default:
        return 'default'
    }
  }

  map = ({adsListSemanticConfig, params: {version}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      version
    })
    return adsListSemanticConfig[adsListSemanticConfigKey] || adsListSemanticConfig.default
  }
}
